import React from "react";

const amountFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const quantityFormatter = new Intl.NumberFormat("en-IN", {
  maximumFractionDigits: 2,
});

const STATUS_META = {
  PendingForReview: { label: "Pending review", tone: "pending", icon: "fa-clock-o" },
  ApprovedBySalesTeam: { label: "Approved", tone: "approved", icon: "fa-check-circle" },
  Rejected: { label: "Rejected", tone: "rejected", icon: "fa-times-circle" },
};

export function formatAmount(value) {
  return amountFormatter.format(Number(value) || 0);
}

export function formatQuantity(value) {
  return quantityFormatter.format(Number(value) || 0);
}

export function formatDate(value, withTime = false) {
  const date = new Date(value);
  return withTime
    ? date.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function getStatusMeta(status) {
  return STATUS_META[status] || {
    label: (status || "Unknown").replace(/([a-z])([A-Z])/g, "$1 $2"),
    tone: "neutral",
    icon: "fa-circle-o",
  };
}

// The sales team picks a distributor on BPUDashContent; its name is stored alongside the id
// so the booking screens can show who the booking is for.
export function rememberSeedBookingDistributor(distributorId, distributorName) {
  localStorage.setItem("distributorId", String(distributorId));
  localStorage.setItem("seedBookingDistributorId", String(distributorId));
  localStorage.setItem("seedBookingDistributorName", distributorName || "");
}

export function getSeedBookingDistributorName(distributorId) {
  return localStorage.getItem("seedBookingDistributorId") === String(distributorId)
    ? localStorage.getItem("seedBookingDistributorName") || ""
    : "";
}

export const StatusBadge = ({ status }) => {
  const meta = getStatusMeta(status);
  return (
    <span className={`sb-status sb-status-${meta.tone}`}>
      <i className={`fa ${meta.icon}`} aria-hidden="true"></i>
      {meta.label}
    </span>
  );
};

export const PageHeader = ({ icon = "fa-leaf", title, subtitle, distributorName, children }) => (
  <div className="sb-header">
    <div className="sb-header-main">
      <span className="sb-header-icon" aria-hidden="true">
        <i className={`fa ${icon}`}></i>
      </span>
      <div className="sb-header-text">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
        {distributorName && (
          <span className="sb-distributor-chip">
            <i className="fa fa-user-circle" aria-hidden="true"></i>
            {distributorName}
          </span>
        )}
      </div>
    </div>
    {children && <div className="sb-header-actions">{children}</div>}
  </div>
);

export const EmptyState = ({ icon = "fa-inbox", title, children }) => (
  <div className="sb-empty">
    <i className={`fa ${icon}`} aria-hidden="true"></i>
    <h2>{title}</h2>
    {children && <div className="sb-empty-body">{children}</div>}
  </div>
);

export const LoadingState = ({ label }) => (
  <div className="sb-loading" role="status">
    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
    {label}
  </div>
);
